import { NgModule } from "@angular/core";
import { CommonModule} from '@angular/common';


import {CollapseComponent} from './exercise-work-collapse/collapse.component';
import {ItemComponent} from './exercise-work-item/item.component';
import {SharedModule} from '../../component/shareModule';
import {ExerciseFinishComponent} from './exercise-work-finish/finish.component';
import {PreviewComponent} from './exercise-work-preview/preview.component';

@NgModule({
  imports: [CommonModule, SharedModule],
    declarations:[
      CollapseComponent,
      ItemComponent,
      PreviewComponent,
      ExerciseFinishComponent,
    ],
    exports:[
      CollapseComponent,
      ItemComponent,
      PreviewComponent,
      ExerciseFinishComponent,
    ]
})

export class ExerciseWorkModule{

}




// WEBPACK FOOTER //
// ./src/app/app-exercise-work/exercise-work.module.ts